var _defs, _rect, _g, _rect2, _g2, _rect3, _g3, _rect4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutMeMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_1",
    "data-name": "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 536.5 726.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d5d6d5;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-5, .cls-6, .cls-11, .cls-13 {\n        stroke: #2d312d;\n      }\n\n      .cls-15 {\n        fill: #ebff92;\n      }\n\n      .cls-2 {\n        fill: #007f21;\n      }\n\n      .cls-16 {\n        fill: #ff9a02;\n      }\n\n      .cls-16, .cls-17 {\n        font-family: DNFBitBitOTF-KSCpc-EUC-H, 'DNF Bit Bit OTF';\n        font-size: 36px;\n      }\n\n      .cls-18 {\n        fill: #9a12ff;\n      }\n\n      .cls-3 {\n        fill: #818381;\n      }\n\n      .cls-17 {\n        fill: #31a8ff;\n      }\n\n      .cls-19 {\n        fill: #001f36;\n      }\n\n      .cls-4 {\n        fill: #ffb35c;\n      }\n\n      .cls-4, .cls-7, .cls-8, .cls-9, .cls-10, .cls-14 {\n        stroke: #000;\n      }\n\n      .cls-5 {\n        fill: #abadab;\n      }\n\n      .cls-20 {\n        fill: #2d312d;\n      }\n\n      .cls-6 {\n        fill: #d00038;\n      }\n\n      .cls-21 {\n        letter-spacing: 0em;\n      }\n\n      .cls-7, .cls-13 {\n        fill: #fff;\n      }\n\n      .cls-8 {\n        fill: #ffc90d;\n      }\n\n      .cls-9 {\n        fill: #004ef9;\n      }\n\n      .cls-10 {\n        fill: none;\n      }\n\n      .cls-11 {\n        fill: #e9bba4;\n      }\n\n      .cls-12 {\n        stroke: #b5b0a6;\n      }\n\n      .cls-12, .cls-14 {\n        fill: #f1eadd;\n      }\n\n      .cls-22 {\n        fill: #ff64ed;\n      }\n\n      .cls-23 {\n        fill: #300;\n      }\n\n      .cls-24 {\n        font-family: K2D-Regular, K2D;\n        font-size: 14px;\n      }\n\n      .cls-25 {\n        letter-spacing: -.07em;\n      }\n\n      .cls-26 {\n        letter-spacing: -.06em;\n      }\n\n      .cls-27 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-28 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-29 {\n        letter-spacing: -.04em;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 0.5,
    y: 0.5,
    width: 381,
    height: 215,
    rx: 20.37,
    ry: 20.37
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M20.46,72.2c-.25,40.08-.51,80.17-.76,120.25,14.09-2,27.81-6.54,40.32-13.33,4.94-2.69,9.95-5.99,12.33-11.09,1.87-3.99,1.89-8.56,1.87-12.97-.07-18.35-.14-36.71-.2-55.06,0-1.48-.03-3.04-.78-4.32-.63-1.08-1.7-1.82-2.73-2.53-4.32-2.96-8.65-5.91-12.99-8.85-9.91-6.73-20.71-13.69-32.68-13.35-2.09.06-4.88,1.4-4.38,1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M73.39,167.66c2.71,3.66,9.38,4.25,11.37.16.72-1.49.69-3.21.65-4.86-.6-21.9-1.2-43.81-1.8-65.71-.02-.81-.07-1.69-.61-2.29-.52-.59-1.37-.75-2.14-.87-2.22-.36-5.04-.44-6.11,1.54-.41.76-.44,1.67-.46,2.54-.43,22.37-.86,44.73-1.29,67.1-.02,1.09.31,2.56.39,2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.62,96.78c2.76-.91,5.88-.64,8.45.73.11,23.02.96,46.03,2.55,68.99-2.86-1.41-7.02,1.1-9.18-1.25-.86-.94-.99-2.32-1.06-3.59-1.31-21.68-1.72-43.4-.76-64.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M302.89,69.23c2.17-4.25,4.73-8.86,9.2-10.52,2.06-.76,4.3-.8,6.49-.83,10.68-.11,21.36-.06,32.04.17,1.55,10.85,1.99,21.85,1.3,32.79-.07,1.06-.18,2.21-.93,2.96-.78.8-2.01.9-3.13.95-11.34.53-22.69,1.07-34.03,1.6-1.01.05-2.08.08-2.96-.43-.79-.46-1.28-1.29-1.71-2.09-3.79-6.98-6-14.8-6.41-22.73-.07-1.27.04-2.79.13-1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M93.02,97.9l.3-5.26c6.7.06,13.41.13,20.11.19,1.78.02,3.86.19,4.84,1.67.57.86.61,1.96.63,3,.42,24.34-.03,48.69-1.35,73-6.06.84-12.23.94-18.32.31-1.6-.17-3.43-.54-4.19-1.95-.38-.7-.41-1.54-.43-2.34-.54-19.9-1.09-39.8-1.63-59.7-.13-4.61-.25-9.24.04-8.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M183.23,76.96c1.99-10.89,2.58-22.03,1.76-33.08-.34-4.55-.85-9.42,1.36-13.42,3.71-6.73,12.87-7.6,20.56-7.65,16.81-.1,33.61-.21,50.42-.24.53.07,1.05.14,1.78.29,5.78-1.23,11.3,2.63,15.96,6.27,5.48,4.28,10.96,8.56,16.43,12.84,4.57,3.57,9.32,7.37,11.66,12.68s1.32,12.59-3.75,15.42c-1.46.81-3.12,1.2-4.75,1.56-13.41,3.04-26.93,5.94-40.65,6.82-10.13.65-20.3.18-30.45-.28-13.5-.62-27.01-1.23-40.34-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.6,87.34c2.24-4.36,4.94-9.1,9.61-10.56,1.9-.59,3.92-.56,5.91-.52,2.84.05,5.67.1,8.51.16,1.07.02,2.46.31,2.58,1.37.06.48-.21.94-.47,1.36-1.42,2.26-3.08,4.37-4.32,6.73-5.11,9.69-2.61,21.95-7.28,31.86-.6,1.28-1.46,2.62-2.83,2.98-1.34.35-2.77-.39-3.63-1.47s-1.27-2.44-1.65-3.77c-2.6-9.07-4.7-18.28-6.29-27.59-.13-.79-.18-1.78-.14-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M203.28,71.16c-4.87-2.05-8.03-7-9.29-12.13s-.9-10.5-.53-15.77c.14-2.05.36-4.28,1.77-5.77,1.62-1.71,4.24-1.87,6.59-1.92,18.6-.4,37.19-.8,55.79-1.2,2.07-.04,4.16-.09,6.18.37,3.86.88,7.05,3.5,10.09,6.03,4.09,3.41,8.18,6.83,12.27,10.24,3.37,2.81,7.05,6.27,6.88,10.66-.12,3.26-2.49,6.11-5.35,7.69s-6.16,2.12-9.39,2.57c-24.45,3.43-49.37,3.52-73.85.27-.74-.1-1.72-.58-1.18-1.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203,76.24c0-3.39,2.69-6.31,5.8-7.64s6.6-1.4,9.99-1.45c5.42-.08,10.84-.16,16.26-.23,23.29-.33,46.57-.67,69.86-1,2.11-.03,4.41,0,6.06,1.33,2.11,1.7,2.29,4.8,2.3,7.51.07,32.95.14,65.89.21,98.84,0,1.92,0,3.91-.75,5.68-2.08,4.91-8.48,5.92-13.8,6.18-28.9,1.44-57.84,2.04-86.78,1.8-4.9-.04-10.2-.25-14-3.34-4.01-3.27-5.19-8.81-6-13.92-1.98-12.48-3.28-25.06-3.89-37.68-.47-9.56-.54-19.13-.24-28.69.19-6.08.59-12.39,3.5-17.73,3.08-5.65,8.57-9.51,11.5-9.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M174.61,140.27c-2.79,10.82-5.15,21.74-7.07,32.75-.2,1.17-.4,2.39-.09,3.54.32,1.2,1.16,2.19,1.98,3.13,1.12,1.3,2.24,2.6,3.37,3.89,1.01,1.16,2.07,2.37,3.49,2.96,1.28.53,2.71.5,4.09.46,3-.08,6.01-.17,9.01-.25,1.73-.05,3.88-.41,4.36-2.06.29-.98-.18-2.01-.63-2.93-5.72-11.87-9.24-24.8-10.32-37.94-.15-1.82-.27-3.7-1.13-5.31s-2.71-2.85-4.48-2.38c-2.52.67-3.08,3.93-2.57,4.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.89,92.17c.69,21.69.29,43.42-1.2,65.07-.24,3.52-.51,7.11.3,10.55s2.9,6.77,6.15,8.16c2.14.92,4.55.91,6.88.89,6.92-.06,13.84-.12,20.75-.18,5.08-.04,10.44-.17,14.76-2.84,4.14-2.56,6.69-7.16,7.81-11.89s1-9.67.86-14.53c-.41-14.76-.82-29.52-1.23-44.28-.17-6-1.23-13.33-6.84-15.47-1.81-.69-3.8-.67-5.73-.64-10.47.17-20.94.34-31.42.51-2.66.04-5.43.11-7.78,1.35s-4.12,4.03-3.33,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184.11,81.41c-3.92,33.5-3.31,67.52,1.8,100.86.2,1.29.47,2.7,1.5,3.51.96.76,2.3.75,3.52.71,4.01-.13,8.02-.26,12.02-.39-.8-3.23-4.34-4.86-6.39-7.47-2.09-2.66-2.55-6.21-2.92-9.57-2.65-23.54-5.29-47.31-2.84-70.87.47-4.5,1.21-9.19,3.92-12.8,2.52-3.36,6.64-5.64,7.97-9.62-3.27.28-6.54.57-9.81.85-2.48.22-5.1.48-7.14,1.9s-3.2,4.45-1.63,2.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M170.6,118.1c-.23,5.51-.22,11.03.02,16.55.04.86.11,1.79.66,2.45.64.77,1.73.95,2.73,1.05,2.27.22,4.56.25,6.84.09.6-.04,1.24-.11,1.72-.48.69-.53.83-1.51.9-2.38.41-5.15.43-10.33.08-15.49-.06-.84-.15-1.75-.74-2.36-.68-.71-1.78-.77-2.76-.79-2.06-.03-4.12-.05-6.17-.08-.93-.01-1.91,0-2.69.49s-1.18,1.69-.58.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M224.54,93.82c-7.02,5.57-1.77,17.8-6.71,25.27-2.43,3.67-6.94,5.52-9.47,9.11-2.63,3.74-2.68,8.66-2.42,13.23.28,5.03.8,10.04,1.56,15.02.21,1.37.47,2.8,1.34,3.88,1.45,1.8,4.06,2.02,6.37,2.09,23.66.75,47.35.71,71.01-.09,3.37-.11,7.13-.42,9.37-2.94,2.11-2.36,2.14-5.86,2.06-9.03-.44-16.71-.87-33.41-1.31-50.12-.06-2.42-.29-5.17-2.19-6.66-1.49-1.17-3.55-1.17-5.44-1.12-21.64.55-43.28,1.3-64.16,1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M278.12,103.23c-.58,16.11-.17,32.26,1.24,48.32.06.7.14,1.44.59,1.98.58.7,1.58.84,2.48.91,1.73.13,3.47.18,5.2.16.65-.01,1.37-.06,1.84-.5.37-.35.52-.87.64-1.37.7-3.05.7-6.21.7-9.35,0-10.68,0-21.35.01-32.03,0-3.92-.31-8.48-3.51-10.74-3.28-2.31-9.08-.3-9.19,2.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M284.84,107.14c-1.54.4-3.16,1.2-3.7,2.69-.64,1.77.84,3.91,2.72,4.04s3.61-1.65,3.54-3.53-1.78-3.4-2.56-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M284.15,122.52c-1.67.3-3.18,1.5-3.69,3.11s.1,3.56,1.53,4.46c2.15,1.36,5.41-.36,5.71-2.89s-2.18-4.94-3.54-4.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M284.16,140.5c-2.03.62-3.6,2.69-3.4,4.8s2.37,3.9,4.45,3.47c2.07-.43,3.35-2.87,2.84-4.93s-2.53-3.76-3.89-3.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M203.79,86.64c-1.58.89-3.24,1.86-4.12,3.45-.6,1.09-.76,2.36-.9,3.6-.85,8.05-.74,16.2.32,24.23.09.68.21,1.4.66,1.9.98,1.08,2.74.53,4.06-.09,3.67-1.74,7.58-3.69,9.48-7.27,1.04-1.96,1.37-4.22,1.59-6.43.4-4.11.49-8.25.27-12.37-.07-1.22-.17-2.47-.7-3.57-.88-1.82-2.81-2.94-4.79-3.34s-4.26-1.02-5.88-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M226.01,111.78l-.51,25.32c-.02,1.17-.02,2.43.68,3.37.91,1.24,2.65,1.45,4.18,1.56,12.88.92,25.92,1.84,38.61-.5.8-.15,1.66-.35,2.16-.99.43-.55.48-1.29.51-1.99.42-8.99.48-18,.17-27-.02-.61-.07-1.28-.48-1.74-.46-.51-1.23-.58-1.92-.61-12.91-.61-25.84-.69-38.75-.22-1.26.05-2.58.12-3.65.79s-1.72,2.17-1,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M236.82,117.63c-.44,4.38-.57,8.79-.39,13.19.02.61.08,1.28.53,1.69.38.36.94.43,1.46.47,6.87.61,13.79.6,20.66-.02.81-.07,1.72-.21,2.2-.86.3-.4.37-.91.43-1.4.52-4.05.63-8.15.34-12.22-.04-.62-.12-1.29-.54-1.75-.52-.56-1.39-.6-2.15-.61-6.53-.02-13.06-.04-19.59-.06-.78,0-1.6,0-2.3.35s-1.24,1.16-.65,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M206.69,94.71c-1.3.14-2.36,1.21-2.85,2.43s-.51,2.57-.48,3.88c.05,3.21.32,6.41.79,9.58,1.99-.06,3.74-1.49,4.73-3.22s1.36-3.74,1.72-5.7c.32-1.76.63-3.66-.14-5.27s-3.09-2.59-3.77-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M353.54,52.69c-3.42,2.17-3.62,7-3.44,11.05.36,7.92.71,15.84,1.07,23.76.08,1.75.16,3.53.73,5.2,1.29,3.81,5.27,6.52,9.29,6.33,1.91-.09,4.05-1.09,4.4-2.97.44-2.39-2.13-4.09-3.57-6.05-1.67-2.26-1.89-5.25-2.05-8.06-.3-5.14-.59-10.29-.89-15.43-.14-2.35-.23-4.88,1.03-6.87.74-1.17,1.88-2.03,2.74-3.12s1.41-2.63.75-3.85c-.55-1.01-1.75-1.47-2.88-1.64-2.98-.46-5.94.88-7.17,1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M185.76,16.98c-2.53,1.94-2.73,5.61-2.71,8.8.06,8.87.12,17.73.19,26.6,0,.49.04,1.04.41,1.36.3.25.72.27,1.11.28,6.46.11,12.92.22,19.38.33,4.64.08,9.37.15,13.82-1.17s8.67-4.25,10.36-8.57c1.05-2.68,1.05-5.63,1.04-8.5,0-2.89-.02-5.78-.03-8.67,0-.74,0-1.49-.18-2.21-.25-1.07-.86-2.02-1.55-2.86-4.89-5.96-13.57-6.83-21.28-6.76-7.21.07-14.42.58-20.56,1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M191.73,25.08c-.97,6.93-1.16,13.97-.57,20.95.05.58.13,1.21.55,1.61.35.33.86.42,1.34.49,1.3.17,2.61.24,3.92.21.75-.02,1.55-.08,2.16-.53.88-.64,1.09-1.85,1.23-2.93.77-6.03,1.54-12.15.65-18.16-.12-.82-.33-1.73-1.02-2.2-.56-.39-1.29-.38-1.97-.35-1.99.07-3.97.14-5.96.21-.19.45-.38.91-.34.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M178.09,31.95c-1.96.51-3.73,2.04-4.12,4.03s.95,4.27,2.95,4.56c2.12.31,4.11-1.73,4.16-3.87s-1.46-4.1-3-4.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173.16,23.61c-10.67-.98-21.45-.89-32.1.27-.48.05-.98.11-1.36.4-.5.37-.69,1.01-.84,1.61-1.51,6.27-1.05,12.82-.59,19.25.11,1.56.36,3.36,1.7,4.17.76.46,1.7.48,2.59.49,9.38.06,18.76.08,28.14.05.4,0,.82,0,1.15-.23.54-.36.62-1.11.65-1.76.29-7.28.59-14.56.88-21.84.03-.85.02-1.82-.22-2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M137.32,29.94c11.78-.11,23.57.04,35.35.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M137.55,36.43c11.78-.24,23.57-.32,35.35-.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M138.22,43.06c11.11.4,22.21.8,33.32,1.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M145.39,23.51c-1.06,8.82-.94,17.77.38,26.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M152.43,23.28c-.16,8.94-.5,17.87-1.02,26.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M183.93,19.04l-10.81.17c-.3,0-.61.01-.87.15-.58.31-.67,1.1-.68,1.77-.15,9.41-.3,18.81-.45,28.22-.01.92,0,1.91.53,2.66.75,1.05,2.21,1.22,3.5,1.3,1.91.12,3.82.23,5.74.35.49.03,1,.06,1.47-.1,1.51-.5,1.83-2.45,1.89-4.04.3-8.27.61-16.53.91-24.8.07-1.88.09-3.93-1.22-5.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M158.33,22.85c-1.23,8.94-1.62,18-1.16,27.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M164.98,23.07c-.5,8.85-.63,17.71-.4,26.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M178.82,33.38c-1.22-1.11-3.34-.75-4.4.52s-1.15,3.14-.57,4.69c.78,2.09,3.33,3.77,5.25,2.62.93-.55,1.44-1.61,1.72-2.65.33-1.22.39-2.56-.14-3.7s-1.79-2-1.86-1.48Z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 2,
    y: 505,
    width: 241,
    height: 221,
    rx: 20.13,
    ry: 20.13
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M91.19,577.29l-1.84-5.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M82.03,519.76c-16.1,7-32.2,14.01-48.31,21.01-3.23,1.41-6.86,3.26-7.65,6.7-.55,2.38.47,4.82,1.47,7.05,5.36,11.97,10.71,23.94,16.07,35.9,1.65,3.68,3.97,7.87,7.97,8.31,1.93.21,3.82-.54,5.6-1.29,15.22-6.4,30.08-13.67,44.46-21.78,1.59-.9,3.25-1.87,4.2-3.43,1.94-3.16.28-7.22-1.39-10.53-7.31-14.48-14.61-28.96-22.43-41.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M107.06,530.54c-6.48,18.33-10.64,37.48-12.35,56.85-.09,1.01-.16,2.07.28,2.98.73,1.49,2.54,2.04,4.15,2.43,16.24,3.91,32.61,7.28,49.07,10.09,1.44.25,3.04.46,4.26-.34,1.16-.76,1.63-2.2,2.02-3.53,5.06-17.5,8.96-35.35,11.67-53.37.14-.91.27-1.86-.03-2.73-.56-1.67-2.42-2.47-4.09-3.04-16.65-5.74-34.11-9.13-51.7-10.03-1.63-.08-3.8.31-3.28.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M128.26,610.21c7.6,14.82,17.14,28.64,28.32,40.99,2.17,2.39,4.91,4.93,8.12,4.53,1.74-.22,3.24-1.29,4.65-2.34,13.24-9.82,26.09-20.17,38.51-31.02,2.81-2.46,5.81-5.33,6.09-9.05.28-3.66-2.14-6.91-4.45-9.75-8.24-10.1-16.84-19.9-25.79-29.38-2-2.12-4.26-4.36-7.15-4.74-3.02-.41-5.88,1.31-8.4,3.01-13.91,9.39-26.5,20.72-37.29,33.56-1.64,1.95-3.22,4.98-2.61,4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M23.36,628.51c11.16,15.31,22.55,30.45,34.16,45.42,1.13,1.45,2.42,3.01,4.23,3.36,2.02.39,3.96-.85,5.65-2.02,2.11-1.47,4.22-2.95,6.33-4.42,1.68-1.17,3.49-2.53,3.93-4.53.51-2.32-1-4.55-2.43-6.45-11.28-14.96-22.56-29.91-33.84-44.87-.57-.75-1.2-1.55-2.11-1.79-1.07-.28-2.16.3-3.12.86-2.26,1.32-4.52,2.64-6.78,3.96-2.37,1.38-4.86,2.89-6.09,5.34s-.5,6.08.08,5.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M23.28,626.68c-2.68-7.49-4.53-15.28-5.51-23.18-.1-.81-.18-1.69.23-2.4,1.02-1.75,3.69-.92,5.4.16,5.44,3.41,10.62,7.25,15.47,11.46.69.6,1.42,1.31,1.44,2.22.03.93-.7,1.7-1.39,2.33-4.74,4.29-10.23,7.75-15.64,9.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M78.59,673.64c-3.93,2.2-7.78,4.56-11.53,7.05-.96.64-2.02,1.48-2.02,2.63,0,.72.44,1.37.94,1.9,2.53,2.69,6.91,3.18,10.25,1.59s5.62-4.96,6.46-8.56c.41-1.73.43-3.77-.81-5.04s-4.01-.75-3.29.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M87.55,626.31c3.75-7.92,9.02-15.11,15.44-21.07.82-.76,1.74-1.53,2.85-1.58,1.2-.05,2.3.8,2.88,1.85s.74,2.28.87,3.47c.85,7.8.72,15.7-.36,23.47-.08.56-.17,1.13-.46,1.62-.97,1.62-3.36,1.32-5.18.81-4.65-1.3-9.31-2.61-13.96-3.91-1.63-.46-3.61-1.35-3.59-3.04.01-1.16,1-2.03,1.5-1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M62.14,676.96c-1.41,1.42-.43,3.84.81,5.4.66.82,1.55,1.67,2.59,1.56.46-.05.87-.27,1.28-.5,4.8-2.69,9.37-5.78,13.64-9.25.65-.52,1.34-1.15,1.4-1.98.06-.75-.43-1.42-.88-2.02-.58-.75-1.15-1.51-1.73-2.26-.47-.61-1.02-1.27-1.79-1.33-.53-.04-1.04.23-1.5.49-5.1,2.9-10.11,6.13-13.83,9.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M17.23,597.52c-.3,3.91.24,7.88,1.56,11.56,2.12-1.27,4.25-2.54,6.37-3.81.4-.24.82-.51.99-.94.29-.73-.27-1.49-.82-2.06-1.91-1.98-4.09-3.7-6.46-5.1-.68-.4-1.59-.48-1.65.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M76.03,660.42c3.32-10.75,6.64-21.51,9.96-32.26.33-1.06.71-2.19,1.61-2.83,1.35-.95,3.2-.38,4.74.22,4.68,1.82,9.37,3.64,14.05,5.46.79.31,1.61.63,2.16,1.27,1.23,1.4.69,3.55.08,5.31-8.9,25.66-18.15,51.19-27.74,76.6-.26.68-.56,1.42-1.21,1.75-.66.34-1.46.15-2.17-.04-5.31-1.46-10.62-2.92-15.93-4.38-1.03-.28-2.12-.6-2.81-1.42-1.24-1.46-.61-3.67.08-5.45,5.95-15.34,12.88-30.34,17.17-44.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M93.61,627.19c-9.85,28.55-19.69,57.11-29.54,85.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M99.66,629.28c-9.33,28.87-19.41,57.49-30.24,85.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M104.48,631.89c-8.75,28.29-18.49,56.26-29.21,83.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M108.53,600.57c-3.99,1.9-7.26,5.27-9.04,9.32,2.48,1.12,5,2.16,7.55,3.11.58.22,1.22.43,1.8.23,1.05-.36,1.24-1.74,1.26-2.85.03-2.07.06-4.14.08-6.21.02-1.51-.33-3.48-1.65-3.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M184.6,659.51c-21.68,10.1-43.03,20.93-63.98,32.47-4.02,2.22-8.11,4.52-11.18,7.94-2.11,2.35-3.39,6.58-.72,8.26,1.61,1.01,3.71.39,5.48-.29,8.76-3.38,17.17-7.61,25.55-11.84,13.91-7.01,27.83-14.02,41.37-21.74,2.78-1.59,5.75-3.42,6.89-6.42,1.15-2.99-.84-7.24-3.41-8.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M197.91,648.2c-5.75,4.01-11.06,8.65-15.79,13.82,1.98,2.04,3.45,4.58,4.24,7.32.15.54.36,1.17.89,1.33.29.09.6.01.89-.06,5.43-1.43,10.84-2.99,16.2-4.66.7-.22,1.5-.55,1.65-1.27.08-.4-.07-.8-.23-1.18-2.24-5.38-4.99-10.55-7.85-15.31Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-17",
    transform: "translate(50.59 576.85) rotate(-22.12)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Ps")), /*#__PURE__*/React.createElement("text", {
    className: "cls-16",
    transform: "translate(112.28 572.47) rotate(14.06)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Ai")), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M166.93,585.76c2.72,8.06.98,16.5-1.3,24.43-2.35,8.16-5.45,16.23-6.19,24.76-.4,4.59.05,9.25,1.7,13.56.68,1.79,3.58,1.01,2.89-.8-3.03-7.92-1.5-16.31.73-24.22,2.31-8.22,5.44-16.28,6.36-24.82.5-4.61.19-9.3-1.3-13.71-.61-1.82-3.51-1.04-2.89.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M170.89,584.35c2.53,7.9,1.46,16.15-.45,24.06s-4.83,16.24-6.09,24.62c-.7,4.67-.87,9.32-.19,14,.28,1.9,3.17,1.09,2.89-.8-1.21-8.31.76-16.67,2.93-24.65,2.19-8.04,4.8-16.09,5.34-24.46.3-4.58-.14-9.2-1.54-13.58-.59-1.83-3.48-1.05-2.89.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M174.18,583.34c3.52,7.68,2.49,16.25.57,24.21-2.04,8.45-5.09,16.67-6.32,25.31-.68,4.79-.78,9.59.18,14.35.38,1.89,3.27,1.09,2.89-.8-1.72-8.57.41-17.29,2.71-25.53,2.31-8.28,5.16-16.67,5.33-25.35.09-4.74-.78-9.38-2.76-13.69-.8-1.75-3.39-.23-2.59,1.51h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.38,648.78c2.71-6.22,7.3-11.45,13.17-14.85,1.67-.97.16-3.56-1.51-2.59-6.27,3.64-11.35,9.27-14.25,15.93-.32.74-.22,1.61.54,2.05.63.37,1.73.21,2.05-.54h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.8,652.75c4.96-4.71,10.61-8.62,16.75-11.64,1.73-.85.21-3.44-1.51-2.59-6.36,3.13-12.22,7.23-17.36,12.11-1.4,1.33.72,3.45,2.12,2.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.11,657.76c7.2-1.74,14.08-4.74,20.25-8.85,1.6-1.07.1-3.67-1.51-2.59-5.97,3.98-12.56,6.87-19.53,8.55-1.88.45-1.08,3.35.8,2.89h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.66,662.5c7.13-.16,14.11-1.8,20.59-4.79,1.75-.81.23-3.39-1.51-2.59-5.98,2.76-12.5,4.23-19.08,4.38-1.93.04-1.93,3.04,0,3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.82,666.9c8.14,1.63,17.46,3.18,24.85-1.67,1.61-1.05.11-3.65-1.51-2.59-6.69,4.38-15.18,2.83-22.54,1.36-1.89-.38-2.69,2.51-.8,2.89h0Z"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1,
    y: 240,
    width: 307,
    height: 248,
    rx: 19.73,
    ry: 19.73
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.8,370.4c-11.25,18.28-19.48,38.41-24.27,59.34-.21.92-.4,1.94.09,2.75.65,1.08,2.15,1.21,3.41,1.22,65.67.38,131.34.76,197.01,1.14,5.81.03,13.25-1.15,14.51-6.82.75-3.35-1.23-6.64-3-9.58-8.21-13.66-13.68-28.97-15.97-44.74-.34-2.34-.78-4.98-2.74-6.3-1.37-.92-3.13-.94-4.78-.93-52.71.43-105.42.86-158.12,1.29-3.97.03-9.44,1.74-6.15,2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.41,260.97c-2.45,36.44-2.84,73.01-.77,111.05,54.86,1.22,109.75,1.02,164.61-.6,2.05-.06,4.22-.16,5.9-1.33,2.83-1.96,3.11-5.97,3.1-9.41-.05-30.63-.36-61.25-.92-91.88-.03-1.69-.08-3.46-.93-4.91-1.68-2.88-5.59-3.32-8.92-3.43-54.15-1.78-108.37-1.21-162.07.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M50.91,273.21c-.39,27.92.33,55.85,2.17,83.71.1,1.57.28,3.3,1.41,4.39,1.2,1.15,3.05,1.2,4.71,1.19,44.93-.51,89.85-1.44,134.76-2.79,1.17-.04,2.42-.09,3.4-.74,1.72-1.14,1.93-3.54,1.96-5.6.37-24.72.53-49.45.46-74.18,0-1.92-.06-3.98-1.19-5.53-1.68-2.29-4.95-2.53-7.79-2.54-46.95-.3-93.91.7-139.89,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M53.6,380.16c-7.09,10.4-12.72,21.8-16.65,33.76-.5,1.53-.98,3.19-.5,4.72.99,3.15,5.08,3.8,8.38,3.89,54.48,1.42,108.99,1.73,163.48.95,1.33-.02,2.73-.06,3.88-.73,3.38-1.97,2.08-7.09.35-10.6-4.73-9.59-9.46-19.19-14.19-28.78-.68-1.39-1.43-2.84-2.73-3.68-1.29-.84-2.92-.92-4.46-.98-46.75-1.73-93.58-1.2-137.57,1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M46.33,391.49l154.62-2.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M39.43,403.46c55.47-.88,110.94-1.76,166.4-2.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M37.8,413.42c58.04-.57,116.08-1.15,174.13-1.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M62.64,380.22c-5.11,14.25-9.85,28.64-14.2,43.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M70.99,381.4c-2.12,13.73-4.25,27.45-6.37,41.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M80.76,380.18c-2.44,13.83-3.53,27.89-3.24,41.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M92.55,378.95c-2.88,14.73-4.19,29.77-3.9,44.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M102.89,378.61l-2.82,45.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M112,381.04l-.97,41.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M125,378.57l-1.08,44.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M137.54,380.21c.13,14.51.26,29.02.39,43.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M147.17,380.19c.93,14.39,1.85,28.77,2.78,43.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M157.23,378.59c.94,15,2.79,29.95,5.51,44.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M167.23,378.58c.99,14.84,3.38,29.59,7.13,43.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M178.6,381.02c.67,14.07,3.12,28.05,7.28,41.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M189.07,380.23l11.27,42.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M214.19,380.17c12.44-2.17,25.93,4.08,32.3,14.99,2.61,4.46,4.07,9.5,6.5,14.07s6.2,8.85,11.26,9.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M265.71,416.55c-7.59,11.88-10.06,26.92-6.65,40.61.91,3.66,2.26,7.3,4.66,10.21s5.99,5.02,9.76,4.93c5.87-.13,10.37-5.24,13.18-10.39,4.38-8.02,6.62-17.19,6.43-26.33-.11-5.29-1.08-10.69-3.76-15.25s-7.29-8.19-12.54-8.79-10.98,2.36-11.07,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M260.86,428.1c10.09,3.75,20.98,5.32,31.72,4.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M278.81,412.35c-.37,6.51-.75,13.02-1.12,19.53"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-24",
    transform: "translate(68.2 302.73)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 0,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 6.82,
    y: 0
  }, "on"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-29",
    x: 21.87,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 28.32,
    y: 0
  }, "t i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 41.29,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 48.02,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-29",
    x: 57.36,
    y: 0
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 64.23,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 70.78,
    y: 0
  }, "y() =&gt; {"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 16.8,
    xmlSpace: "preserve"
  }, "    s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 21.53,
    y: 16.8
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 28.5,
    y: 16.8
  }, "tI"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 37.9,
    y: 16.8
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 44.63,
    y: 16.8
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-29",
    x: 53.97,
    y: 16.8
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 60.84,
    y: 16.8
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 67.4,
    y: 16.8
  }, "y(t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 85.37,
    y: 16.8
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 90.69,
    y: 16.8
  }, "ue)"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 33.6
  }, "}")))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 327,
    y: 239,
    width: 209,
    height: 321,
    rx: 19.96,
    ry: 19.96
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M484.86,506.57c-.67,6.24-1.35,12.48-2.02,18.72-.2,1.83-.39,3.71.1,5.48s1.83,3.44,3.64,3.75c1.46.25,2.94-.4,4.12-1.3,2.41-1.82,3.94-4.55,5.34-7.22,3.64-6.92,7-14.16,8.01-21.92.27-2.09.36-4.3-.48-6.24-1.52-3.52-5.52-5.14-9.14-6.41-1.81-.64-3.98-1.24-5.54-.11-.77.55-1.23,1.43-1.62,2.3-2.25,4.97-2.14,10.44-2.41,12.95Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M416.57,361.51c-5.53,9-9.53,18.94-11.77,29.27-.86,3.93-1.45,8.06-.45,11.96.9,3.49,3.02,6.53,5.19,9.42,4.22,5.62,8.77,11,13.61,16.09,2.61,2.74,5.56,5.54,9.29,6.19"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M418.65,337.09l3.52,14.71c.13.52.28,1.09.7,1.42.53.41,1.27.31,1.92.16,3.79-.83,7.4-2.46,10.53-4.74.67-.49,1.34-1.03,1.67-1.78.38-.85.27-1.84.12-2.76-.6-3.59-1.79-7.08-3.51-10.29-.52-.97-1.14-1.97-2.12-2.47-.96-.49-2.1-.43-3.18-.35-2.32.16-4.74.36-6.75,1.55s-3.16,3.59-2.93,4.56Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M402.47,380.67c-3.25.38-6.45,1.25-9.45,2.56-1.03,4.45-1.99,9.43.35,13.36,2.28,3.82,7.57,5.42,11.66,3.66,4.08-1.76,6.55-6.56,5.77-10.94s-4.62-7.98-8.33-8.64Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M415.82,361.08c1.56,24.98,6.68,49.73,15.16,73.27.93,2.57,2.34,5.52,5.04,5.95,1.21.19,2.42-.19,3.58-.57,7.4-2.39,14.79-4.78,22.19-7.18,1.38-.44,2.82-.93,3.79-1.99,1.13-1.23,1.43-2.98,1.63-4.63,2.77-22.48-3.61-45.96-17.38-63.94-1.59-2.08-3.32-4.13-5.51-5.56-7.42-4.85-17.24-1.4-25.36,2.15-2.13.93-4.57,3.59-3.15,2.51Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M441.39,343.84l-3.01,5.65c13.17,14.81,22.3,33.17,26.15,52.61,2.26,11.41,2.83,23.42,8.09,33.79,5.26,10.37,17.33,18.66,28.29,14.77,9.93-3.53,14.35-14.85,17.29-24.97,3.46-11.86,6.56-24.27,4.52-36.45-2.46-14.75-12.42-27.55-24.88-35.81s-27.24-12.41-42.03-14.58c-3.37-.49-6.89-.88-10.1.26s-5.97,4.24-4.33,4.74Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M460.02,383.52c6.34,4.95,15.43,5.37,22.97,2.54s13.71-8.46,18.81-14.68c1.1-1.35,2.2-2.79,2.57-4.49.47-2.12.17-5.02,2.21-5.73"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M501.82,355.76l-4.77,6.21c5.24,6.01,10.48,12.01,15.72,18.02.22.25.45.51.76.61.33.1.68,0,.99-.13,2.25-.96,3.11-3.89,2.52-6.27s-2.26-4.32-3.9-6.14c-3.8-4.19-7.77-8.23-11.33-12.31Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M448.12,459.31c-1.73,7.27-.25,14.88,1.24,22.2,1.12,5.56,2.4,11.42,6.28,15.55,2.54,2.71,5.96,4.41,9.42,5.76,6.33,2.48,13.04,3.98,19.81,4.45,2.28-4.4,4.57-8.8,6.85-13.19.38-.74.78-1.57.57-2.37-.19-.72-.82-1.23-1.42-1.66-3.1-2.24-6.58-3.96-10.24-5.07-2.39-.73-4.93-1.23-6.95-2.7-2.62-1.9-3.95-5.14-4.62-8.31-2.88-13.55,3.59-28.64-2.53-41.06-.44-.88-1-1.8-1.92-2.15-1.34-.51-2.77.39-3.88,1.3-9.39,7.78-10.99,20.42-12.61,27.25Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M437.06,438.3c-22.35,22.4-42.13,47.36-58.83,74.23,3.46,2.94,7.29,5.45,11.36,7.46,1.43.71,2.99,1.37,4.58,1.18,1.89-.22,3.41-1.57,4.81-2.87,22.57-20.9,45.38-42.07,62.25-67.79,3.2-4.88,6.3-10.49,5.33-16.25-.21-1.24-.66-2.53-1.63-3.33-1.19-.98-2.88-1.02-4.42-.94-9.67.55-19.4,4.25-23.44,8.3Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M380.51,513.39c-.84-3.34-4.78-4.67-8.14-5.45-2.07-.48-4.15-.97-6.22-1.45-3.72-.87-7.52-1.74-11.32-1.39s-7.68,2.17-9.54,5.51c-.69,1.24-1.07,2.78-.51,4.08.36.84,1.05,1.48,1.74,2.07,7.22,6.18,16.4,9.51,25.5,12.26,5.32,1.61,11.5,2.94,16.1-.17,2.33-1.58,3.86-4.06,5.31-6.48.34-.56.69-1.19.56-1.83-.14-.7-.78-1.16-1.37-1.55-4.99-3.24-10.18-6.18-12.12-5.6Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M421.68,351.58c-3.88,2.01-6.16,6.7-5.35,10.98.68,3.58,3.18,6.5,5.68,9.15s5.18,5.32,6.37,8.76.36,7.91-2.86,9.61c-1.18.62-2.54.81-3.88.85-5.71.13-11.42-2.69-14.79-7.3-.9,3.39-1.81,6.78-2.71,10.16-.32,1.22-.65,2.48-.41,3.72.56,2.89,3.8,4.29,6.61,5.17,11.4,3.55,24.71,5.99,34.54-.78,6.69-4.6,10.32-12.88,10.41-21.01.09-8.12-3.04-16.04-7.63-22.74-3.28-4.79-7.63-9.26-13.25-10.7-5.62-1.44-12.56,1.21-12.75,4.13Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M416.34,263.61c-16.28-.4-31.75,12.25-35.1,28.19s5.39,33.47,19.9,40.86c14.51,7.39,33.48,4.38,45.35-6.77,5.03-4.72,8.87-10.76,10.74-17.41,3.4-12.08-.21-25.86-9.09-34.73s-22.67-12.45-31.79-10.15Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M401.77,266.99c7.79,8.85,15.57,17.7,23.36,26.56,6.86,7.8,13.8,15.67,22.29,21.65s18.79,9.99,29.13,9.03c2.08-.19,4.33-.69,5.61-2.34,2.42-3.11-.45-7.79-4.02-9.44s-7.76-1.73-11.21-3.62c-4.11-2.26-6.52-6.76-7.76-11.29s-1.53-9.27-2.68-13.82c-2.88-11.47-11.62-21.49-22.88-25.11s-24.64-.29-31.84,8.37Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 401,
    cy: 293,
    r: 4.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 272,
    y: 577,
    width: 264,
    height: 149,
    rx: 20.12,
    ry: 20.12
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 401,
    y: 1,
    width: 135,
    height: 215,
    rx: 20.18,
    ry: 20.18
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutMeMenu);
export default __webpack_public_path__ + "static/media/about_me_menu.4d00c968a62dd0c2192c70a8e9dd17a8.svg";
export { ForwardRef as ReactComponent };